export const PKCE_SESSION_VERIFIER_SOURCE = 'sfdc_pkce_verifier_source';
export const PKCE_SESSION_VERIFIER_TARGET = 'sfdc_pkce_verifier_target';

const PKCE_LOCAL_PREFIX = 'sfdc_pkce_nonce_';

function base64UrlEncodeBytes(bytes: Uint8Array): string {
    let binary = '';
    for (let i = 0; i < bytes.byteLength; i += 1) {
        binary += String.fromCharCode(bytes[i]!);
    }
    return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function base64UrlEncodeBuffer(buffer: ArrayBuffer): string {
    return base64UrlEncodeBytes(new Uint8Array(buffer));
}

export function generateCodeVerifier(): string {
    const array = new Uint8Array(32);
    crypto.getRandomValues(array);
    return base64UrlEncodeBytes(array);
}

export async function generateCodeChallenge(verifier: string): Promise<string> {
    const data = new TextEncoder().encode(verifier);
    const hash = await crypto.subtle.digest('SHA-256', data);
    return base64UrlEncodeBuffer(hash);
}

export function appendPkceToUrl(authorizeUrl: string, codeChallenge: string): string {
    const u = new URL(authorizeUrl);
    u.searchParams.set('code_challenge_method', 'S256');
    u.searchParams.set('code_challenge', codeChallenge);
    return u.toString();
}

export function generatePkceNonce(): string {
    const a = new Uint8Array(16);
    crypto.getRandomValues(a);
    return Array.from(a, (b) => b.toString(16).padStart(2, '0')).join('');
}

export function storePkceVerifierForNonce(nonce: string, verifier: string): void {
    try {
        localStorage.setItem(PKCE_LOCAL_PREFIX + nonce, verifier);
    } catch {
        /* storage unavailable */
    }
}

export function consumePkceVerifierForNonce(nonce: string): string | null {
    const key = PKCE_LOCAL_PREFIX + nonce;
    try {
        const v = localStorage.getItem(key);
        localStorage.removeItem(key);
        return v;
    } catch {
        return null;
    }
}

const SFDC_OAUTH_CALLBACK = '/sfdc/{mode}/oauth2/callback';

export function sfdcOAuthCallbackUrl(mode: 'source' | 'target'): string {
    return `${window.location.origin}${SFDC_OAUTH_CALLBACK.replace('{mode}', mode)}`;
}
